/**
 * Maintenance — full-page gate shown when maintenance_mode is active.
 *
 * Replaces all routes in App.tsx. No nav, no auth — this is the only thing
 * visible until maintenance mode is turned off in the admin dashboard.
 */
import { useTranslation } from 'react-i18next'


interface MaintenanceProps {
  message?: string | null
}

export default function Maintenance({ message }: MaintenanceProps) {
  const { t } = useTranslation()
  return (
    <div
      className="min-h-svh flex flex-col items-center justify-center px-6"
      style={{
        background:
          'radial-gradient(ellipse at 60% 0%, rgba(155,114,192,0.10) 0%, transparent 55%), #FAF7F4',
      }}
    >
      {/* Logo mark */}
      <div
        className="mb-8 flex items-center justify-center"
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#3D1F62',
        }}
      >
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <circle cx="11" cy="11" r="4.5" fill="white" opacity="0.9" />
          <circle cx="11" cy="11" r="9" stroke="white" strokeWidth="1.5" opacity="0.35" />
        </svg>
      </div>

      {/* Wordmark */}
      <p
        className="text-xs font-medium uppercase tracking-widest mb-8"
        style={{ color: '#9B72C0' }}
      >
        {t('home.appName')}
      </p>

      {/* Headline */}
      <h1
        className="font-display text-3xl text-center mb-4"
        style={{
          color: '#1C1128',
          fontWeight: 400,
          fontStyle: 'italic',
          maxWidth: 320,
          lineHeight: 1.3,
        }}
      >
        {t('maintenance.stillness')}
      </h1>

      {/* Message */}
      <p
        className="text-center text-sm leading-relaxed"
        style={{ color: '#6B5F7A', maxWidth: 300 }}
      >
        {message || t('maintenance.defaultMessage')}
      </p>

      {/* Subtle divider */}
      <div
        className="mt-10"
        style={{ width: 32, height: 1, background: '#D5C3E8' }}
      />

      <p className="mt-4 text-xs" style={{ color: '#B8A8C8' }}>
        nixxtech.com
      </p>
    </div>
  )
}
